import { useState, useEffect, useRef } from "react";
import { getStepGroups } from "../../../store/actions/stepActionCreators";
import { ListOrdersPayloadDto } from "../../../store/actions/dtos/ListOrdersPayloadDto";

export function useGroupFilters(
  getOrderList: (payload: ListOrdersPayloadDto) => void,
  listOrdersPayload: ListOrdersPayloadDto,
  setListOrdersPayload: (payload: ListOrdersPayloadDto) => void
) {
  const [groupFilters, setGroupFilters] = useState<string[]>([]);
  const [selectedGroupsFilters, setSelectedGroupsFilters] = useState<string[]>(
    []
  );
  const groupFilterDebounceRef = useRef<ReturnType<typeof setTimeout> | null>(
    null
  );

  useEffect(() => {
    getStepGroups().then(([groups]) => {
      if (groups) setGroupFilters(groups);
    });
  }, []);

  const handleGroupFilterChange = (newGroups: string[]) => {
    setSelectedGroupsFilters(newGroups);
    const newPayload = {
      ...listOrdersPayload,
      SearchByGroups: newGroups.join(","),
    };
    setListOrdersPayload(newPayload);
    if (groupFilterDebounceRef.current)
      clearTimeout(groupFilterDebounceRef.current);
    groupFilterDebounceRef.current = setTimeout(() => {
      getOrderList(newPayload);
    }, 50);
  };

  const handleViewAll = () => {
    const allSelected = selectedGroupsFilters.length === groupFilters.length;
    handleGroupFilterChange(!allSelected ? [...groupFilters] : []);
  };

  return {
    groupFilters,
    selectedGroupsFilters,
    handleGroupFilterChange,
    handleViewAll,
  };
}
